/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID } from '@gh/common-shared-data';
import { createEnum, date, DateFormat, entity, enumeration, EnumSet } from '@gh/core-data';

export const ScheduledTaskStatus = createEnum('SCHEDULED_TASK_STATUS', {
  Success: 'SUCCESS',
  Failed: 'FAILED',
  PartialSuccess: 'PARTIAL_SUCCESS',
});

export type ScheduledTaskStatus = EnumSet<typeof ScheduledTaskStatus>;

export type StlListItemDto = {
  id: ID;
  name: string;
  startTime: Date;
  endTime: Date;
  status: string;
  statusValue: ScheduledTaskStatus;
  resultMessage: string;
};

export const StlMapper = entity<StlListItemDto>({
  startTime: date(DateFormat.DateTime),
  endTime: date(DateFormat.DateTime),
  statusValue: enumeration(ScheduledTaskStatus),
});
